import { FunctionComponent, KeyboardEvent, useState } from "react";

import { faXmark } from "@fortawesome/pro-regular-svg-icons";

import { Icon } from "@/components/Icon/Icon";

interface RoutingTextValuesProps {
	values: string[];
	onChange: (values: string[]) => void;
	placeholder: string;
	removeLabel: string;
}

/** Free words for a text condition (Job title contains …): Enter adds one, ✕ removes it. */
export const RoutingTextValues: FunctionComponent<RoutingTextValuesProps> = ({
	values,
	onChange,
	placeholder,
	removeLabel,
}) => {
	const [text, setText] = useState("");

	const handleKeyDown = (event: KeyboardEvent<HTMLInputElement>) => {
		if (event.key !== "Enter") {
			return;
		}

		event.preventDefault();

		const word = text.trim();

		if (word && !values.includes(word)) {
			onChange([...values, word]);
		}

		setText("");
	};

	return (
		<div className="flex min-w-0 flex-1 flex-wrap items-center gap-1 rounded-md border border-border-light bg-brand-white px-2 py-1">
			{values.map((value) => (
				<span
					className="flex items-center gap-1 rounded-full bg-background-light px-2 py-0.5 text-xs text-text"
					key={value}
				>
					{value}
					<button
						aria-label={`${removeLabel} ${value}`}
						className="cursor-pointer text-text-meta"
						type="button"
						onClick={() => onChange(values.filter((other) => other !== value))}
					>
						<Icon className="h-3 w-3" icon={faXmark} />
					</button>
				</span>
			))}
			<input
				className="min-w-[120px] flex-1 bg-transparent text-sm outline-none"
				data-testid="routing-text-input"
				placeholder={placeholder}
				type="text"
				value={text}
				onChange={(event) => setText(event.target.value)}
				onKeyDown={handleKeyDown}
			/>
		</div>
	);
};
